<template>
    <div class="app-container" style="background-color: #f9fbff;">
        <div class="review-title-content">
            <div class="reasons-title">
                <h3>キンライサーの口コミ</h3>
            </div>
        </div>
        <div class="card">
            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">お見積りの時から感じがよく、お願いした次の日には、工事が出来、夕方には完了しました。</p>
                <p class="review-content-text">このスピーディーさは、凄いと思います。あと、<span class="under-yellow">工事&商品が10年保証と言うのは、長年使う給湯器には、有りがたいですね！</span></p>
                <p class="review-content-text">お見積りは、一番安くは無いですが、この<span class="under-yellow">保証や、営業マンや工事担当者さんの対応はピカ１</span>です。</p>
                <p class="google-review">引用：Google口コミ</p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">14年使った給湯器がエラー続きでついに交換が必要に。<br>
                    某ガス会社は37万で4～5日後、管理会社経由でも32万で1週間後との見積もり。</p>
                <p class="review-content-text">一方キンライサーは27万で2日後に工事可能と<span class="under-yellow">迅速かつ安価で、対応も丁寧でした。</span>
                    実際の施工も安心でき、依頼して正解でした。</p>
                <p class="review-content-text">壊れてからでは慌てるので、10年を目安に早めの交換が大切だと実感しました。</p>
                <p class="google-review">引用：みな評</p>
            </div>

            <!-- <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★</span>
                        <span class="rating-score">評価4</span>
                    </div>
                </div>
                <p class="review-content-text">キンライサーで給湯器の入替え工事。<br><span class="under-yellow">家電量販店よりも安い見積でこちらに決定。</span></p>
                <p class="review-content-text">当日はほぼ時間通りに開始。リモコンの設置穴が小さかったらしく、コードのしまい込みに苦慮してましたが無事に設置。</p>
                <p class="review-content-text">本体の設置もスムーズで、予告通り2時間程度で終了。<span class="under-yellow">特に問題なく、丁寧な施工でした。</span></p>
                <p class="google-review">引用：Google口コミ</p>
            </div> -->
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.app-container {
    background: #f9fbff;
    padding: 40px 20px;
}

.reasons-title {
    margin-bottom: 30px;
    text-align: center;
}

.reasons-title h3 {
    font-size: 32px;
    font-weight: 800;
    margin: 0;
    line-height: 1.2;
    background: linear-gradient(90deg, #3f51b5, #3F51B5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
}

.reasons-title h3::after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: #3f51b5;
    margin: 12px auto 0;
    border-radius: 2px;
}

.card {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.review-content {
    background: #fff;
    padding: 25px 20px;
    border: 1px solid #eee;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    text-align: left;
}

.review-header {
    margin-bottom: 12px;
}

.rating-point-box {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #555;
}

.rating-stars {
    color: #ffc107;
    font-size: 18px;
    letter-spacing: 2px;
}

.rating-score {
    font-size: 18px;
    font-weight: bold;
    color: #d9534f;
}

.google-review {
    text-align: right;
    font-size: 12px;
    padding-bottom: 0;
    margin-bottom: 0;
}

.review-header img {
    width: 60px;
    height: auto;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .review-content-text {
        font-size: 0.9rem;
    }

    .google-review {
        font-size: 0.7rem;
    }

    .rating-point-box img {
        width: 20%;
    }

    .rating-stars,
    .rating-score {
        font-size: 0.9rem;
    }

    .reasons-title h3 {
        font-size: 1.5rem
    }

    .rating-stars {
        font-size: 1.2rem;
    }
}
</style>
